if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      getCartElement() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      onSubmitHandler(event) {
        event.preventDefault();

        const cart = this.getCartElement();

        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        const addUrl = this.form.getAttribute('action') || '/cart/add';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then((response) => {
            const contentType = response.headers.get('content-type') || '';

            if (!contentType.includes('application/json')) {
              throw new Error('Cart add did not return JSON. URL: ' + addUrl);
            }

            return response.json();
          })
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || response.message);
              return;
            }

            const updatedCart = this.getCartElement();

            if (updatedCart && typeof updatedCart.renderContents === 'function') {
              updatedCart.renderContents(response);
            } else if (updatedCart && typeof updatedCart.open === 'function') {
              updatedCart.open();
            } else {
              console.warn('Cart drawer not found after add.');
            }
          })
          .catch((error) => {
            console.error('Product form error:', error);
            this.handleErrorMessage('Something went wrong. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            const cart = this.getCartElement();

            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}